import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { Button, buttonVariants } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";
import Authorized from "components/Authorized";

// A plain Link rather than Button's render prop: Base UI's Button adds
// role="button" to the anchor, so it would not be announced as a link.
// Semantic UI's unlayered `a` colour rules beat Tailwind's layered utilities,
// so the link restates the default variant's text colour with `!`.
const LINK_CLASSES = cn(
  buttonVariants({ size: "sm" }),
  "tw:text-primary-foreground! tw:hover:text-primary-foreground!"
);

/**
 * A table's create action. `to` renders a link to the create route; `onClick`
 * runs a custom create flow. `permissions` gates the button when given.
 */
export function TableCreateButton({
  to,
  onClick,
  permissions,
  isLoading = false,
  children,
}) {
  const button = to ? (
    <Link to={to} className={LINK_CLASSES}>
      {children}
    </Link>
  ) : (
    <Button size="sm" disabled={isLoading} onClick={onClick}>
      {isLoading && <Spinner data-icon="inline-start" />}
      {children}
    </Button>
  );

  if (!permissions) return button;
  return <Authorized permissions={permissions}>{button}</Authorized>;
}

TableCreateButton.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  permissions: PropTypes.array,
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
